export const mockConferences = [
  {
    id: '1',
    title: 'WTSFest Berlin | Women in Tech SEO',
    description: 'The Women In Tech SEO Festival is a full-day, community-led conference returning for its sixth year on International Women\'s Day. This one-time event features...',
    date: '2026-01-08',
    location: 'Berlin, Germany',
    categories: ['General Search'],
    priceRange: '£99 - £499',
    format: 'In-Person',
    websiteUrl: 'www.womenintechseo.com',
    ticketUrl: 'https://www.womenintechseo.com',
    coverImage: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80',
    organizerEmail: 'contact@womenintechseo.com',
    status: 'approved'
  },
  {
    id: '2',
    title: 'WTSFest London 2026',
    description: 'The Women In Tech SEO Festival is a full-day, community-led conference returning for its sixth year on International Women\'s Day. This one-time event features...',
    date: '2026-01-08',
    location: 'London, United Kingdom',
    categories: ['General Search'],
    priceRange: '£99 - £499',
    format: 'In-Person',
    websiteUrl: 'www.womenintechseo.com',
    ticketUrl: 'https://www.womenintechseo.com',
    coverImage: 'https://images.unsplash.com/photo-1591115765373-5207764f72e7?w=800&q=80',
    organizerEmail: 'contact@womenintechseo.com',
    status: 'approved'
  },
  {
    id: '3',
    title: 'Visibility Summit Dubai 2026 – AI, SEO & Social for Marketers',
    description: 'Dubai Knowledge Park Conference Centre/Auditorium',
    date: '2026-02-04',
    location: 'Dubai Knowledge Park Conference Centre/Auditorium',
    categories: ['Analytics & AI'],
    priceRange: '$299 - $499',
    format: 'In-Person',
    websiteUrl: 'visibilitysummit.com',
    ticketUrl: 'https://visibilitysummit.com',
    coverImage: 'https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=800&q=80',
    organizerEmail: 'contact@visibilitysummit.com',
    status: 'approved'
  },
  {
    id: '4',
    title: 'eTail Palm Springs 2026 | eCommerce Retail Conference',
    description: 'With a focus on digital commerce, this event is a four-day retreat designed to help ecommerce and retail professionals connect...',
    date: '2026-02-23',
    location: 'JW Marriott Desert Springs Resort, CA',
    categories: ['General Search'],
    priceRange: 'Free / Invite',
    format: 'In-Person',
    websiteUrl: 'etailwest.wbresearch.com',
    ticketUrl: 'https://etailwest.wbresearch.com',
    coverImage: 'https://images.unsplash.com/photo-1591115765373-5207764f72e7?w=800&q=80',
    organizerEmail: 'contact@wbresearch.com',
    status: 'approved'
  },
  {
    id: '5',
    title: 'Search Marketing Expo (SMX Munich)',
    description: 'SMX Munich is large event with +1000 attendees focused on search marketing, attracting a diverse range of industry professionals. It offers a...',
    date: '2026-03-10',
    location: 'Munich, Germany',
    categories: ['Content Strategy', 'General Search'],
    priceRange: '£99 - £499',
    format: 'In-Person',
    websiteUrl: 'smxmuenchen.de',
    ticketUrl: 'https://smxmuenchen.de',
    coverImage: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80',
    organizerEmail: 'contact@smxmuenchen.de',
    status: 'approved'
  },
  {
    id: '6',
    title: 'Friends Of Search Fest',
    description: 'One of Europe\'s largest search conferences. The event brings together consultants, marketers, and business owners to share their insights on SEO...',
    date: '2026-03-12',
    location: 'Amsterdam, Netherlands',
    categories: ['Technical SEO', 'Analytics & AI', 'General Search'],
    priceRange: '$299 - $499',
    format: 'In-Person',
    websiteUrl: 'friendsofsearch.com',
    ticketUrl: 'https://friendsofsearch.com',
    coverImage: 'https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=800&q=80',
    organizerEmail: 'contact@friendsofsearch.com',
    status: 'approved'
  }
];

export const mockBlogPosts = [
  {
    id: '1',
    title: 'Top SEO Conferences to Attend in 2026',
    slug: 'top-seo-conferences-2026',
    excerpt: 'Discover the must-attend SEO conferences happening around the world in 2026. From technical SEO to content strategy...',
    content: '<p>Full blog content here...</p>',
    coverImage: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80',
    author: 'Admin',
    publishedAt: '2025-12-15',
    metaTitle: 'Top SEO Conferences to Attend in 2026',
    metaDescription: 'Discover the must-attend SEO conferences happening around the world in 2026.'
  },
  {
    id: '2',
    title: 'How to Choose the Right SEO Conference for You',
    slug: 'choose-right-seo-conference',
    excerpt: 'With so many SEO conferences available, how do you choose the right one? Here are key factors to consider...',
    content: '<p>Full blog content here...</p>',
    coverImage: 'https://images.unsplash.com/photo-1591115765373-5207764f72e7?w=800&q=80',
    author: 'Admin',
    publishedAt: '2025-12-10',
    metaTitle: 'How to Choose the Right SEO Conference',
    metaDescription: 'Learn how to choose the perfect SEO conference for your needs.'
  }
];

export const categories = [
  { id: 'all', name: 'All Events', icon: 'globe' },
  { id: 'technical-seo', name: 'Technical SEO', icon: 'code' },
  { id: 'content-strategy', name: 'Content Strategy', icon: 'pen-tool' },
  { id: 'analytics-ai', name: 'Analytics & AI', icon: 'bar-chart' },
  { id: 'local-seo', name: 'Local SEO', icon: 'map-pin' },
  { id: 'link-building', name: 'Link Building', icon: 'link' },
  { id: 'general-search', name: 'General Search', icon: 'search' }
];

export const formats = ['All', 'Online', 'In-Person', 'Hybrid'];

export const months = [
  'All Months',
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];